import {
    Box,
    Typography,
    IconButton,
  } from '@mui/material';
  import {
    CloudUpload,
    Download,
    OpenInNew,
  } from '@mui/icons-material';
import { formatDate } from 'utils/helper';


export const PointsManagementColumns = (handleDownload: (fileUrl: string) => void, handleOpenDetailModal: (id: number) => void) => [
    {
      field: 'createdAt',
      headerName: 'Ngày tạo',
      width: 180,
      renderCell: (params: any) => {
        return formatDate(new Date(params.value));
      },
    },
    {
      field: 'fileName',
      headerName: 'Tên file',
      width: 250,
      align: 'center' as const,
      justifyContent: 'center' as const,
      renderCell: (params: any) => (
        params.value
      ),
    },
    {
      field: 'totalRecords',
      headerName: 'Tổng số bản ghi',
      width: 150,
      align: 'center' as const,
    },
    {
      field: 'successfulRecords',
      headerName: 'Thành công',
      width: 120,
      align: 'center' as const,
      justifyContent: 'center' as const,
      renderCell: (params: any) => (
        params.value
      ),
    },
    {
      field: 'failedRecords',
      headerName: 'Lỗi',
      width: 100,
      align: 'center' as const,
      justifyContent: 'center' as const,
      renderCell: (params: any) => (
        params.value
      ),
    },
    {
      field: 'actions',
      headerName: 'Thao tác',
      width: 120,
      sortable: false,
      renderCell: (params: any) => (
        <>
          <IconButton
            onClick={() => handleDownload(params.row.fileUrl)}
            color="primary"
            size="small"
          >
            <Download />
          </IconButton>
        </>
      ),
    },
  ];